export default __webpack_public_path__ + "static/209-0cd174e2f078df05228af4b85f141b57.gif";